<template>

  <MainLayout />

</template>

<script>
import MainLayout from './layouts/MainLayout.vue'

export default {

  name: 'App',

  components: {
    MainLayout
  }

}
</script>

<style>

html,
body,
#app {
  display: inline-block;
  width: 100%;
  height: 100%;
}

</style>